<template>
	<div class="d-flex flex-column flex-grow-1 overflow-hidden my-2 px-3">
		<v-sheet
			outlined
			rounded
			class="visible-all-users d-flex align-center flex-grow-0 flex-shrink-0 px-4 py-2 mb-3"
		>
			<v-switch
				class="mt-0 pt-0 pl-1 flex-grow-0"
				hide-details
				dense
				:input-value="visibleToAllUsers"
				label="Visible to all users"
				@change="$emit('visible-to-all-users-changed', $event)"
			/>
			<v-icon
				small
				class="ml-6 mr-2"
				:color="visibleToAllUsers ? 'info' : ''"
				>{{
					visibleToAllUsers
						? 'mdi-account-group'
						: 'mdi-account-check'
				}}
			</v-icon>
			<span class="caption text--secondary">{{ hint }}</span>
		</v-sheet>
		<assign-user />
	</div>
</template>
<script>
import AssignUser from './AssignUser.vue';
export default {
	name: 'ReportAssignUser',
	props: {
		visibleToAllUsers: Boolean,
	},
	data() {
		return {};
	},
	computed: {
		hint() {
			return this.visibleToAllUsers
				? 'Everyone in the project can see this report, no matter which users are assigned below.'
				: 'Only the users assigned below can see this report.';
		},
	},
	components: { AssignUser },
};
</script>
